/**
 * Vuex module for per-company account-level preferences (e.g. default dashboard).
 * Hydrated from /auth/login + /auth/profile responses; mirrors projectSettings.js.
 *
 * Persisted to localStorage so the post-login `/` redirect resolves correctly
 * on a hard reload — the redirect runs synchronously before the router guard
 * has a chance to hit /auth/profile and rehydrate Vuex.
 */
const FALLBACK_DASHBOARD_PATH = "/dashboard/erp";
const STORAGE_KEY = "accountSettings";

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function saveToStorage(value) {
  try {
    if (value && Object.keys(value).length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* quota / disabled storage — non-fatal */
  }
}

const persisted = loadFromStorage();

export const state = {
  defaultDashboardPath: persisted?.defaultDashboardPath || null,
};

export const getters = {
  defaultDashboardPath: (state) =>
    state.defaultDashboardPath && state.defaultDashboardPath.trim()
      ? state.defaultDashboardPath
      : FALLBACK_DASHBOARD_PATH,
};

export const mutations = {
  SET_SETTINGS(state, settings) {
    state.defaultDashboardPath = settings?.defaultDashboardPath || null;
    saveToStorage({ defaultDashboardPath: state.defaultDashboardPath });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
